import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

@Injectable()
export class EnvService {

  constructor (private http: Http) {}

  /**
  * ---------------------------------------------
  * Retrieve the server variable holding the env
  * @returns {Observable} string
  * ---------------------------------------------
  */
  public getEnv(): Observable<string> {
    return this.http.get('/env').map( res => res.json().results || { })
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/env.service.ts